module.exports = __webpack_public_path__ + "static/6305-woodrose-39-2df25114b5387a6b67b3c9ce07338d2c.jpg";